// @flow

import * as React from 'react';

import type { DecoratedProduct } from '@gandi/cart';
import { useTranslator } from '@gandi/translate';
import { Base, PopoverIcon } from '@gandi/ui';

import { useAppSelector } from 'src/hooks/useAppSelector';

import { ListRow } from '../../ListRow';
import { selectNameserversUrl } from '../selectors';

import Price from './components/Rows/Price';

type Props = {
  product: DecoratedProduct,
};

export function PremiumDNSRenew({ product }: Props): React.MixedElement {
  const { unitPrice, hasTaxes, expirationDate, fqdn } = product;
  const nameserversUrl = useAppSelector(state =>
    // $FlowIgnore[incompatible-call] - fqdn is defined, otherwise there cant be no renew
    selectNameserversUrl(state, fqdn),
  );
  const translator = useTranslator();
  const { __, formatDate } = translator;

  const dateEnd = expirationDate ? formatDate(expirationDate, 'LL') : undefined;

  const popoverInfo = (
    <PopoverIcon
      icon="infoWire"
      id={`popover-info-premiumDNS-${product.id}`}
      behaviour="click"
    >
      <Base tagName="p" marginTop="none">
        {' '}
        {__(
          "Premium DNS is automatically renewed with your domain name. The price is calculated to match the domain's expiration date.",
        )}
      </Base>{' '}
      <Base tagName="p" marginBottom="none">
        {__(
          "If you don't want to renew Premium DNS service, you need to unsubscribe first.",
        )}{' '}
        <a href={nameserversUrl}>{__('View nameservers page')}</a>
      </Base>
    </PopoverIcon>
  );

  const label = (
    <>
      {__('For')} {fqdn || ''}
    </>
  );
  const detail = (
    <Base flex flexAlignItemsCenter>
      {dateEnd && __('Domain expires on %(dateEnd)s', { dateEnd })}
      {popoverInfo}
    </Base>
  );

  return (
    <ListRow
      title={label}
      options={[detail]}
      optionsArrow={false}
      price={
        <Price
          price={unitPrice}
          priceInfo={` / ${__('month')}`}
          showExcludeVatMention={hasTaxes}
        />
      }
    />
  );
}
